<script setup lang="ts">
import { watchEffect, ref, defineProps } from 'vue';
import ContactCheckbox from './ContactCheckbox.vue'
import TreatmentForm from './TreatmentForm.vue'

const { phone, token } = defineProps(['phone', 'token'])
const treatments = ref([])
const message = ref('')

const loadTreatments = async () => {
  const resp: any = await await fetch(`/customer/${phone}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      'Authorization': `Bearer ${token}`
    }
  })
  if (!resp?.error) {
    treatments.value = resp.data.sort((a: any, b: any) => a.id - b.id)
  }
}

watchEffect(async () => {
  return loadTreatments()
})

const scheduleTreatment = async (contact: any, type: string) => {
  console.log('scheduleTreatment', contact.id, type)
  const response = await fetch(`/contacts/${contact.id}/${type}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      'Authorization': `Bearer ${token}`
    }
  })
  if (response.ok) {
    return loadTreatments()
  }
}
const onSaveSuccess = async () => {
  return loadTreatments()
}
const onSaveFail = async (text: string) => {
  return message.value = text
}
</script>

<template>
  <div v-if="message" class="flex items-center justify-between mt-4">
    {{ message }}
  </div>

  <ContactForm 
    :token="token"
    :customer-id="customerId"
    @on-save-success="onSaveSuccess"
    @on-save-fail="onSaveFail" />
  
  <table  class="w-full text-center table-auto min-w-max">
    <thead>
      <tr>
        <th>Telefone</th>
        <th>Cliente</th>
        <th title="Já recebeu mensagem">Validado</th>
        <th title="Já agendou tratamento">Verificado</th>
        <th title="Ultimo telefone fornecido na presença das consultas ou pagamento como titular">Último</th>
        <th title="Sempre será usado">Fixado</th>
        <th title="Nunca será usado">Bloqueado</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(contact) in contacts" :key="id">
        <td>{{ contact.value }}</td>
        <td>{{ contact.customer.name }}</td>
        <td><ContactCheckbox :contact-id="contact.id" :checked="contact.validated" disabled="true" property="validated"/></td>
        <td><ContactCheckbox :contact-id="contact.id" :checked="contact.verified" disabled="true" property="verified"/></td>
        <td><ContactCheckbox :contact-id="contact.id" :checked="contact.last" disabled="true" property="last"/></td>
        <td><ContactCheckbox :contact-id="contact.id" @updateContact="updateContact(contact, 'fix')" :checked="contact.fixed"  property="fixed"/></td>
        <td><ContactCheckbox :contact-id="contact.id" @updateContact="updateContact(contact, 'block')" :checked="contact.blocked" property="blocked"/></td>
      </tr>
    </tbody>
  </table>
</template>
